import { render, staticRenderFns } from "./AllergyList.vue?vue&type=template&id=59d2500b"
import script from "./AllergyList.vue?vue&type=script&lang=js"
export * from "./AllergyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports